import React, { useMemo } from 'react';

import { Avatar, Box, Card, CardContent, Typography } from '@mui/material';
import { VideocamOutlined } from '@mui/icons-material';
import { useCurrentuser, useCurrentuserRefetch } from '@uplift/contexts';
import { trackStartSessionClick, useL10n } from '@uplift/hooks';
import { UserRole } from '@uplift/types';
import { Button } from '@uplift/ui-v2';

import { ConnectionTips } from '../../../modals/connection-tips';
import { usePreVideoStyles } from '../../pre-video-call.styles';
import { InfoComponentProps } from './info.component';

export const DesktopInfoComponent: React.FC<InfoComponentProps> = ({
  onSubmit,
  startButtonDisabled,
  companionRole,
  userName,
  userAvatar,
  startTime,
  endTime,
  sessionNote,
}) => {
  const l10n = useL10n();
  const { classes } = usePreVideoStyles();
  const me = useCurrentuser();
  const { refetchUser } = useCurrentuserRefetch();

  const currentUser = useMemo(() => {
    if (!me) {
      refetchUser();
    }
    return me;
  }, [ me, refetchUser ]);

  const handleOnSubmit = (session: any) => {
    trackStartSessionClick({
      userType: UserRole[currentUser?.role]
    });
    onSubmit(session);
  };

  const companionIsProvider = companionRole === 'provider';

  return (
    <Box className={classes.detailsBlock}>
      <Box className={classes.timeRange}>
        {startTime} - {endTime}
      </Box>
      <Box className={classes.headTitle}>{l10n.sessions.readyToJoin}</Box>
      <Card className={classes.infoCard}>
        <CardContent>
          <Box display="flex" pt={1} pl={1}>
            {userAvatar && (
              <Box pr={2}>
                <Avatar alt={`${userName.first} ${userName.last}`} src={userAvatar} className={classes.avatar} />
              </Box>
            )}
            <Box display="flex" justifyContent="center" flexDirection="column">
              <Typography className={classes.userName} variant="body1">{userName.first} {userName.last}</Typography>
              {sessionNote && (
                <Typography className={classes.patientText}>
                  {sessionNote}
                </Typography>
              )}
            </Box>
          </Box>
        </CardContent>
      </Card>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-evenly"
        mb={4}
        width="100%"
      >
        {companionIsProvider && (
          <Typography>{l10n.sessions.connectionTroublesText}</Typography>
        )}
      </Box>
      <Box className={classes.enterSessionBlock}>
        <Button
          disabled={startButtonDisabled}
          color="secondary"
          variant="contained"
          onClick={handleOnSubmit}
          startIcon={<VideocamOutlined />}
        >
          {l10n.sessions.joinSession}
        </Button>
        <ConnectionTips />
      </Box>
    </Box>
  );
};
